// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollTopButton_root__9HqwR","visible":"ScrollTopButton_visible__Jjb6Y","fab":"ScrollTopButton_fab__A8WPJ"};